import {Button, ConfigProvider, Input} from "antd";
import React, {useEffect} from "react";
import WorkforceDetailsFieldComponent from "../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {postMapLocation} from "../../../Services/map";
import {Controller} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";

const CaseLocationDetails = ({control, handleSubmit, setValue}) => {
    const dispatch = useDispatch();
    const { createWorkforceCaseDetails } = useSelector((state) => state.Workforce);

    useEffect(() => {
        setValue("fullAddress", createWorkforceCaseDetails?.address);
        setValue("geocode", createWorkforceCaseDetails?.geocode);

    },[createWorkforceCaseDetails]);

    const onLocate = (data) => {
        dispatch(SET_IS_API_CALLED("Retrieving Geocode"));
        postMapLocation({fullAddress: data?.fullAddress})
            .then((response) => {
                if (response !== undefined && response !== null) {
                    setValue("geocode", `${response?.geometry?.location.lat} , ${response?.geometry?.location.lng}`)
                }
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });
    }

    return (
        <>
            <div className="flex flex-col gap-2">
                <div className="text-sm font-bold">
                    <label htmlFor={"location"}>
                        <p>Location</p>
                    </label>
                </div>
                <div>
                    <ConfigProvider
                        theme={{
                            token: {
                                colorPrimary: "blue",
                                borderRadius: 5,
                            },
                        }}
                    >
                        <Controller
                            name="fullAddress"
                            control={control}
                            render={({field}) => (
                                <WorkforceDetailsFieldComponent fieldName={""} fieldId={"fullAddress"}>
                                    <Input
                                        placeholder=""
                                        id={"fullAddress"}
                                        value={field.value}
                                        onChange={field.onChange}/>
                                </WorkforceDetailsFieldComponent>)}
                        />
                    </ConfigProvider>
                </div>
            </div>

            <div className="grid grid-cols-6">
                <div className="content-end">
                    <ConfigProvider>
                        <Button
                            onClick={handleSubmit(onLocate)}
                            className="w-full bg-medium-blue-100 text-white"
                        >
                            Locate
                        </Button>
                    </ConfigProvider>
                </div>
                <div className="col-span-2 col-end-7">
                    <Controller
                        name="geocode"
                        control={control}
                        render={({field}) => (
                            <WorkforceDetailsFieldComponent
                                fieldName={"Geocode"}
                                fieldId={"geocode"}
                            >
                                <Input
                                    placeholder="0,0" id={"geocode"}
                                    disabled={true}
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            </WorkforceDetailsFieldComponent>
                        )}/>
                </div>
            </div>
        </>
    );
};

export default CaseLocationDetails;
